import { render, staticRenderFns } from "./PET_TC_zx.vue?vue&type=template&id=2b53e9aa&scoped=true&"
import script from "./PET_TC_zx.vue?vue&type=script&lang=js&"
export * from "./PET_TC_zx.vue?vue&type=script&lang=js&"
import style0 from "./PET_TC_zx.vue?vue&type=style&index=0&id=2b53e9aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b53e9aa",
  null
  
)

component.options.__file = "PET_TC_zx.vue"
export default component.exports